module.exports = __webpack_public_path__ + "img/icono-transporte.32b4d465.png";